import { WithChildrenProps } from "@app/types/generalTypes";
import * as S from "./BaseActionsWrapper.styles";

interface BaseActionsWrapperProps extends WithChildrenProps {
  justify?: "start" | "center" | "end" | "space-between" | "space-around";
}

export const BaseActionsWrapper: React.FC<BaseActionsWrapperProps> = ({
  children,
  justify = "end",
}) => {
  return (
    <S.ActionsWrapper justify={justify}>
      {children}
    </S.ActionsWrapper>
  );
};
